import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import injectStyles from 'react-jss'
import ControlBar from './../../modules/ControlBar'
import CrossIcon from './CrossIconSvg'
import NewRepositoryDialog from './NewRepositoryDialog'

const Page = injectStyles({
  content: {
    paddingTop: 160,
    whiteSpace: 'nowrap',
    overflowX: 'auto',
  },
  title: {
    display: 'inline-block',
    width: 300,
    textAlign: 'center',
    paddingRight: 40,
    textAlign: 'right',
    boxSizing: 'border-box',
    '@global h3': {
      marginTop: 50,
    },
  },
})(({ classes, children }) => <div>
  <ControlBar />
  <div className={classes.content}>
    <div className={classes.title}>
      <h3>Repositories</h3>
      <h5>(recently contributed to)</h5>
    </div>
    {children}
  </div>
</div>)

export default Page


class UnstyledContainer extends Component {

  state = {
    newRepoDialogOpen: false,
  }

  onAddRepoClick = () => this.setState({ newRepoDialogOpen: true })

  onCloseNewRepoDialog = () => this.setState({ newRepoDialogOpen: false })

  render = () => {
    const { ownerId, title, children, classes, first } = this.props
    const { newRepoDialogOpen } = this.state

    return <div className={classes.group} style={{marginLeft: first ? 0 : undefined }}>
      <h3>{title}</h3>
      <CrossIcon className={classes.crossIcon}
        onClick={this.onAddRepoClick}
      />
      {newRepoDialogOpen ?
        ReactDOM.createPortal(
          <NewRepositoryDialog
            ownerId={ownerId}
            onClose={this.onCloseNewRepoDialog}
          />,
          document.body
        ) : null}
      {children}
    </div>
  }
}

const StyledContainer = injectStyles({
  group: {
    position: 'relative',
    width: 445,
    backgroundColor: 'white',
    border: '1px solid #ebedf0',
    display: 'inline-block',
    verticalAlign: 'top',
    padding: 32,
    boxSizing: 'border-box',
    marginRight: 34,
    marginLeft: 34,
    '@global h3': {
      fontWeight: 'bold',
      fontSize: 26,
      margin: '10px 0 30px 0',
    },
  },
  crossIcon: {
    position: 'absolute',
    top: 42,
    right: 32,
    cursor: 'pointer'
  },
})(UnstyledContainer)


export const RepositorySelectGroup = ({ ownerId, first, title, children, classes }) =>
  <StyledContainer ownerId={ownerId} title={title} first={first}>
    <StyledList>
      {React.Children.map(children, c => <StyledItem>{c}</StyledItem>)}
    </StyledList>
  </StyledContainer>


const StyledList = injectStyles({
  list: {
    paddingLeft: 0,
    listStyle: 'none',
  },
})(({ classes, children }) => <ul className={classes.list}>
  {children}
</ul>)

const StyledItem = injectStyles({
  item: {
    marginTop: 20,
    marginBottom: 20,
  },
})(({ children, classes }) => <li className={classes.item}>
  {children}
</li>)


// WEBPACK FOOTER //
// ./src/pages/RepositorySelect/RepositorySelect.js